import React,{Component} from 'react'
import bahtah from '../bahtah.png'

class LandingComponent extends Component{
	render(){
	 return(
	  <div>
	   <header className="App-header">
	    <h1 style={{fontSize: "70pt"}}>Bahtah Bing!</h1><br/><br/><br/>
	    <img src={bahtah} className="App-logo" alt="logo" />
	   </header>
	  </div>
	 )
	}
}

export default LandingComponent
